import axiosInstance from '../../config/axiosInstance';
import {
  BackupFile,
  MigrationInfo,
  MigrationOptions,
  MigrationPreview,
  SystemRun,
  SystemRunKind,
} from '../../types/system';

const BASE = '/system';
const migrationPath = (id: string) => `${BASE}/migrations/${encodeURIComponent(id)}`;

/** The System page: migrations and backups (platform owner only). */
export class SystemService {
  async listMigrations(): Promise<MigrationInfo[]> {
    return axiosInstance.get(`${BASE}/migrations`);
  }

  async previewMigration(id: string, options: MigrationOptions): Promise<MigrationPreview> {
    return axiosInstance.post(`${migrationPath(id)}/preview`, options);
  }

  async runMigration(id: string, options: MigrationOptions): Promise<SystemRun> {
    return axiosInstance.post(`${migrationPath(id)}/run`, options);
  }

  async listRuns(kind?: SystemRunKind): Promise<SystemRun[]> {
    return axiosInstance.get(`${BASE}/runs`, { params: { kind } });
  }

  async getRun(id: string): Promise<SystemRun> {
    return axiosInstance.get(`${BASE}/runs/${id}`);
  }

  async revertRun(id: string): Promise<SystemRun> {
    return axiosInstance.post(`${BASE}/runs/${id}/revert`);
  }

  async listBackups(): Promise<BackupFile[]> {
    return axiosInstance.get(`${BASE}/backups`);
  }

  async createBackup(): Promise<SystemRun> {
    return axiosInstance.post(`${BASE}/backups`);
  }

  async restoreBackup(fileName: string, confirmDatabase: string): Promise<SystemRun> {
    return axiosInstance.post(`${BASE}/backups/restore`, { fileName, confirmDatabase });
  }

  async databaseName(): Promise<{ name: string }> {
    return axiosInstance.get(`${BASE}/database`);
  }
}

export const systemService = new SystemService();
